import { useNavigate } from "react-router-dom";
import { BookOpen, Mail } from "lucide-react";

const Footer = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBooksClick = () => {
    navigate('/');
    setTimeout(() => {
      document.getElementById('books')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleColoringClick = () => {
    navigate('/coloring-pages');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-emerald-900 py-12 px-4">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-3 gap-8 text-white">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <BookOpen className="h-6 w-6 text-amber-500" />
              <span className="font-serif font-bold text-lg gold-text-outline">Cornerstone Ink</span>
            </div>
            <p className="text-slate-300 text-sm">Inspiring readers with faith-based stories, romance novels, mystery thrillers, coloring books for kids, self-help books, and more.</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4 gold-text-outline">Quick Links</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>
                <button onClick={handleHomeClick} className="hover:text-amber-500 transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={handleBooksClick} className="hover:text-amber-500 transition-colors">
                  Books
                </button>
              </li>
              <li>
                <button onClick={handleColoringClick} className="hover:text-amber-500 transition-colors">
                  Coloring Pages
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 gold-text-outline">Contact</h4>
            <p className="text-sm text-slate-300 mb-3">For inquiries, please reach out:</p>
            <a 
              href="mailto:cornerstoneink@outlook.com" 
              className="text-amber-500 hover:text-amber-400 transition-colors flex items-center gap-2"
            >
              <Mail className="h-4 w-4" />
              cornerstoneink@outlook.com
            </a>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-emerald-800 text-center text-sm text-slate-400">
          &copy; 2024 Cornerstone Ink. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
